import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=61a4be64&scoped=true"
import script from "./courseList.vue?vue&type=script&lang=js"
export * from "./courseList.vue?vue&type=script&lang=js"
import style0 from "./courseList.vue?vue&type=style&index=0&id=61a4be64&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a4be64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a4be64')) {
      api.createRecord('61a4be64', component.options)
    } else {
      api.reload('61a4be64', component.options)
    }
    module.hot.accept("./courseList.vue?vue&type=template&id=61a4be64&scoped=true", function () {
      api.rerender('61a4be64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/professionalTeaching/courseList.vue"
export default component.exports